import { render } from "./read-setting.vue?vue&type=template&id=2919ba6e&scoped=true"
import script from "./read-setting.vue?vue&type=script&lang=js"
export * from "./read-setting.vue?vue&type=script&lang=js"

import "./read-setting.vue?vue&type=style&index=0&id=2919ba6e&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2919ba6e"]])

export default __exports__